import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, ArrowLeft, Facebook, Instagram, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const EMAIL = "info@upsmartlearning.co.uk";

export default function ContactUs() {
  return (
    <div className="min-h-screen bg-[#EFE8D8] grain">
      <header className="bg-[#595C2B] text-white">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="contactus-brand">
            <img src="/logo_mark.png" alt="Up Smart Learning" className="h-9 w-9 object-contain" />
            <span className="font-display text-lg font-bold">Up Smart Learning</span>
          </Link>
          <Link to="/"><Button variant="ghost" className="text-white hover:bg-white/10 rounded-full" data-testid="contactus-back-btn"><ArrowLeft className="h-4 w-4 mr-2" />Home</Button></Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <span className="inline-flex items-center gap-2 rounded-full border border-[#BA8A30]/50 bg-[#BA8A30]/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-[#8a6a1c]">
            <CalendarCheck className="h-3.5 w-3.5" /> Book your free meeting
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#595C2B] mt-6 tracking-tight">Let's arrange your free meeting</h1>
          <p className="text-lg text-[#4a4f3c] mt-4 leading-relaxed max-w-xl">
            Email us to book a free, no-obligation meeting where we'll discuss your child's goals and build a personalised learning plan together.
          </p>

          <div className="mt-10 rounded-2xl border border-[#d8cfb8] bg-white p-8">
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#BA8A30]">Email us</p>
            <a href={`mailto:${EMAIL}?subject=Free%20meeting%20request`} className="mt-3 flex items-center gap-3 group" data-testid="contactus-email-link">
              <span className="h-12 w-12 rounded-xl bg-[#595C2B] flex items-center justify-center shrink-0"><Mail className="h-6 w-6 text-[#BA8A30]" /></span>
              <span className="font-display text-2xl font-semibold text-[#595C2B] group-hover:underline break-all">{EMAIL}</span>
            </a>
            <a href={`mailto:${EMAIL}?subject=Free%20meeting%20request&body=Hi%20Up%20Smart%20Learning%2C%0A%0AI%27d%20like%20to%20arrange%20a%20free%20meeting%20to%20discuss%20a%20learning%20plan.%0A%0AChild%27s%20year%20group%2Flevel%3A%20%0ASubject(s)%3A%20%0APreferred%20times%3A%20%0A%0AThank%20you.`}>
              <Button size="lg" className="mt-6 rounded-full bg-[#BA8A30] hover:bg-[#9C7328] text-[#2A1E0E] font-semibold btn-lift h-12 px-8" data-testid="contactus-email-btn">
                <Mail className="h-4 w-4 mr-2" /> Email us to book your free meeting
              </Button>
            </a>
            <p className="text-sm text-[#6a6f58] mt-4">We aim to respond to all enquiries promptly, usually within one working day.</p>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-6 text-[#4a4f3c]">
            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#595C2B]" data-testid="contactus-facebook"><Facebook className="h-5 w-5 text-[#BA8A30]" /> Up Smart Learning</a>
            <a href="https://www.instagram.com/up_smart_learning" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#595C2B]" data-testid="contactus-instagram"><Instagram className="h-5 w-5 text-[#BA8A30]" /> @UP_SMART_LEARNING</a>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
